import React from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'
import UsersHoverIcon from '~images/users_hover.svg'
import MonitorIcon from '~images/monitor.svg'
import BarChartIcon from '~images/bar_chart.svg'
import StatisticLineIcon from '~images/statistic_line.svg'

const ChatFeatures = () => {
  return (
    <Screen
      title={<span>Что позволяют<StyledScreen.GreenText> делать</StyledScreen.GreenText> чаты</span>}
      bottomLine
      className='chat-features'
    >
      <div className='chat-features__container'>
        <div className='chat-features__feature'>
          <div className='chat-features__feature-header'>
            <div className='chat-features__feature-header-icon'><UsersHoverIcon /></div>
            <div className='chat-features__feature-header-title'>Общаться с клиентом там, где удобно и вам, и клиенту</div>
          </div>
          <div className='chat-features__feature-body'>
            Клиент выбирает удобный канал коммуникации и становится более лояльным, а менеджер общается с клиентом прямо из CRM и экономит время.
          </div>
        </div>
        <div className='chat-features__feature'>
          <div className='chat-features__feature-header'>
            <div className='chat-features__feature-header-icon'><StatisticLineIcon /></div>
            <div className='chat-features__feature-header-title'>Сократить время ответа и не допустить ухода клиента к конкуренту</div>
          </div>
          <div className='chat-features__feature-body'>
            По статистике большинство клиентов ожидают, что им ответят на запрос в течение 2-3 минут, если этого не происходит — они обращаются в другое место.
          </div>
        </div>
        <div className='chat-features__feature'>
          <div className='chat-features__feature-header'>
            <div className='chat-features__feature-header-icon'><MonitorIcon /></div>
            <div className='chat-features__feature-header-title'>Сохранить клиента в CRM с историей сделки при смене менеджера</div>
          </div>
          <div className='chat-features__feature-body'>
            Вы не будете зависеть от менеджеров и текучки, ваша клиентская база будет под надежной защитой.
          </div>
        </div>
        <div className='chat-features__feature'>
          <div className='chat-features__feature-header'>
            <div className='chat-features__feature-header-icon'><BarChartIcon /></div>
            <div className='chat-features__feature-header-title'>Повысить конверсию в продажу в переписке</div>
          </div>
          <div className='chat-features__feature-body'>
            Руководитель отдела продаж сможет контролировать скрипты и отработку возражений в переписке также, как при прослушке звонков.
          </div>
        </div>
      </div>
    </Screen>
  )
}

export default ChatFeatures;